import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText,MdFilterList
} from './ThemeLayoutHelpers';

export default function CircuitLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#0ea5e9";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Circuit • Tech Store",
    title: "Sharp tech. Smart prices.",
    subtitle: "Explore the latest electronics, gadgets, and smart devices — all in one place.",
    primaryCta: "Browse Tech",
    secondaryCta: "Store Info",
  });
  return (
    <div className="min-h-screen flex flex-col bg-[#f0f8fe]" style={{ fontFamily: T.fontFamily || "Inter, sans-serif" }}>
      <div className="w-full py-1.5 text-center text-[11px] font-bold uppercase tracking-[0.2em]" style={{ backgroundColor: primary, color: "#fff" }}>
        {p.storeInfo?.businessCategory || p.storeInfo?.businessName}
      </div>
      <nav className="sticky top-0 z-40 border-b border-sky-200 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-sky-200" />
          <div>
            <p className="text-sm font-bold text-sky-900">{p.storeInfo?.businessName}</p>
            <p className="text-[10px] text-sky-500 tracking-wide font-medium">{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={() => p.setFilterPanelOpen(true)} className="hidden md:flex items-center gap-1.5 px-3 py-2 rounded-xl border border-sky-200 text-sm font-semibold" style={{ color: primary }}>
              <MdFilterList /> {text.filter || "Filter"}
            </button>
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-xl border border-sky-200 hover:bg-sky-50" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="rounded-3xl overflow-hidden shadow-[0_18px_55px_rgba(14,165,233,0.24)]">
          <HeroImage p={p} themeId="circuit" className="h-[340px] md:h-[420px]">
            <div className="absolute inset-0 bg-gradient-to-r from-sky-950/90 via-sky-900/60 to-transparent" />
            <div className="absolute inset-0 max-w-7xl px-8 md:px-12 flex flex-col justify-center pb-4">
              <span className="inline-block text-[10px] uppercase tracking-[0.28em] font-bold px-3 py-1 rounded-full mb-3" style={{ backgroundColor: primary + "28", color: "#7dd3fc" }}><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
              <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight max-w-xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
              <p className="mt-3 text-sky-200/75 max-w-md text-sm"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
              <div className="mt-6 flex gap-3">
                <button onClick={() => p.setActiveTab("products")} className="px-6 py-3 rounded-xl text-sm font-bold text-white shadow-lg" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
                <button onClick={() => p.setActiveTab("details")} className="px-6 py-3 rounded-xl text-sm font-semibold text-white/70 border border-white/20"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
              </div>
            </div>
          </HeroImage>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-3">
          {[{l:text.products || "Products", v: p.filteredProducts?.length||0, c:"bg-sky-50 border-sky-200 text-sky-900"},{l:text.services || "Services", v: p.filteredServices?.length||0, c:"bg-indigo-50 border-indigo-200 text-indigo-900"},{l:"24h", v:"24h", c:"bg-cyan-50 border-cyan-200 text-cyan-900"}].map(s => (
            <div key={s.l} className={`rounded-2xl border px-4 py-3 ${s.c}`}>
              <p className="text-[11px] font-semibold">{s.l}</p>
              <p className="text-xl font-extrabold mt-0.5">{s.v}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-sky-200 bg-white p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-xl text-sm font-semibold whitespace-nowrap" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#0c4a6e" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}

// ─── Slate ───────────────────────────────────────────────────────────────────